import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import "./AdminPackage.css";
import CancellationForm from "./CancellationForm";
import { updatePackagePrice } from "../axios";

function Policydetails(props) {
  const [packageID, setPackageID] = useState(props?.policyData?.id);
  const [basePrice, setBasePrice] = useState(props?.policyData?.total_price);
  const [sellingPrice, setSellingPrice] = useState(props?.policyData?.total_price);
  const [discountPercentage, setDiscountPercentage] = useState(
    props?.policyData?.discount_percentage !== undefined
      ? props?.policyData?.discount_percentage
      : 0
  );

  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();

  useEffect(() => {
    setValue("sellingPrice", props?.policyData?.selling_price);
    setValue("discountPercentage", props?.policyData?.discount_percentage);
    setValue("offer_description", props?.policyData?.offer_description);
  }, [props?.policyData]);

  const handleSellingPriceChange = (value) => {
    const price = parseFloat(value);
    if (!isNaN(price)) {
      const discount = ((basePrice - price) / basePrice) * 100;
      setSellingPrice(price);
      setDiscountPercentage(discount.toFixed(2));
      setValue("discountPercentage", discount.toFixed(2));
    }
  };

  const handleDiscountPercentageChange = (value) => {
    const discount = parseFloat(value);
    if (!isNaN(discount)) {
      const price = basePrice - (basePrice * discount) / 100;
      setDiscountPercentage(discount);
      setSellingPrice(price.toFixed(2));
      setValue("sellingPrice", price.toFixed(2));
    }
  };

  const onSubmit = (data) => {
    let package_id = packageID;
    let selling_price = data.sellingPrice;
    let discount_percentage = data.discountPercentage;
    let offer_description = data.offer_description;

    updatePackagePrice(
      package_id,
      selling_price,
      discount_percentage,
      offer_description
    ).then(
      (data) => {
        window.location.reload(true);
      },
      (error) => {}
    );
    reset();
  };

  return (
    <div className="summaryWrapper">
      <div className="summaryContainer">
        <h6>Cancellation Rule & Price Offers</h6>
        <div className="summaryDetailsWrapper">
          <div className="summaryCardWrapper">
            <CancellationForm  cancellation={props?.policyData.cancellation} policies={props?.policyData?.policies} packageID={props?.policyData.id}/>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="summaryCardWrapper">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="form-group col-lg-4">
                        <div className="floating-label-wrap">
                          Default Amount
                        </div>
                      </div>
                      <div className="form-group col-lg-4">
                        <div className="floating-label-wrap">Amount</div>
                      </div>
                      <div className="form-group col-lg-4">
                        <div className="floating-label-wrap">Discount</div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-lg-4">
                        <div className="floating-label-wrap" id="amounttype">
                          <input
                            type="number"
                            className="floating-label-field floating-label-field--s3"
                            placeholder="Default Amount"
                            id="basePrice"
                            name="basePrice"
                            autocomplete="off"
                            readOnly
                            value={basePrice}
                            onChange={(e) =>
                              setBasePrice(parseFloat(e.target.value) || 0)
                            }
                          />
                          <span>
                            <span className="text-danger"></span>{" "}
                          </span>
                        </div>
                      </div>

                      <div className="form-group col-lg-4">
                        <div className="floating-label-wrap" id="amounttype">
                          <input
                            type="number"
                            className="floating-label-field floating-label-field--s3"
                            placeholder="Amount"
                            step="0.01"
                            {...register("sellingPrice", {
                              required: "Selling price is required",
                              min: {
                                value: 0,
                                message: "Selling price cannot be less than 0",
                              },
                              max: {
                                value: basePrice,
                                message: `Selling price cannot be more than ${basePrice}`,
                              },
                            })}
                            value={sellingPrice}
                            onChange={(e) => handleSellingPriceChange(e.target.value)}
                            autocomplete="off"
                          />
                          <span className="text-danger">
                            {errors.sellingPrice && errors.sellingPrice.message}
                          </span>
                        </div>
                      </div>

                      <div className="form-group col-lg-4">
                        <div className="floating-label-wrap" id="amounttype">
                          <input
                            className="floating-label-field floating-label-field--s3"
                            placeholder="Offer(%)"
                            type="number"
                            step="0.01"
                            {...register("discountPercentage", {
                              required: "Discount percentage is required",
                              min: {
                                value: 0,
                                message: "Discount percentage cannot be less than 0",
                              },
                              max: {
                                value: 100,
                                message: "Discount percentage cannot be more than 100",
                              },
                            })}
                            value={discountPercentage}
                            onChange={(e) => handleDiscountPercentageChange(e.target.value)}
                          />
                          <span className="text-danger">
                            {errors.discountPercentage && errors.discountPercentage.message}
                          </span>
                        </div>
                      </div>
                      <h6>Offer Details</h6>
                      <div className="forroles">
                        <textarea
                          id="offer_description"
                          {...register("offer_description")}
                          placeholder="Add any notes here..."
                          name="offer_description"
                          className="floating-label-field floating-label-field--s3"
                          autocomplete="off"
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-lg-12 mt-3">
                      <button type="submit" className="btn btn-success">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Policydetails;
